import React, { useCallback, useEffect, useState } from 'react';
import * as api from '../api';
import { money, Panel, PeriodPick } from '../shared';
import Loader from '../../hr/components/Loader';

// Payroll Inputs: what T&A (overtime, missed days, lateness, leave monetization, timesheets) and approved HR Expenses have put on
// payroll for the month. Read only — they are changed at their source.
export default function InputsRegister() {
  const [period, setPeriod] = useState('');
  const [d, setD] = useState(null);
  const [error, setError] = useState('');
  const load = useCallback(p => api.inputsRegister(p).then(r => { setD(r); setPeriod(r.period); setError(''); }).catch(e => setError(e.message)), []);
  useEffect(() => { load(''); }, [load]);
  if (error) return <div className="error">{error}</div>;
  if (!d) return <Loader title="Loading payroll inputs…" />;
  return (
    <Panel title={`Payroll inputs — ${d.period_label}`} note="From T&A and approved HR Expenses. Read only: change them where they came from."
           actions={<PeriodPick value={period} periods={d.periods} onChange={load} />}>
      <div className="table-wrap"><table style={{ fontSize: 13 }}><thead><tr><th>ID</th><th>Name</th><th>Type</th><th className="num">Amount</th><th>Description</th><th>Status</th><th>Payroll run</th></tr></thead>
        <tbody>{d.rows.map(r => (
          <tr key={r.id}><td className="mono" style={{ whiteSpace: 'nowrap' }}>{r.employee_no}</td><td><b>{r.name}</b></td><td className="small">{r.type}</td><td className="num">{money(r.amount)}</td>
            <td className="small">{r.description}</td><td>{r.status}</td><td>{r.payroll_reference || '—'}</td></tr>))}
          {!d.rows.length && <tr><td colSpan={7} className="muted">Nothing for {d.period_label}.</td></tr>}
        </tbody></table></div>
    </Panel>
  );
}
